import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { IMultiplyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/multiply-model.interface';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

const DEFAULT_VALUE = 1;

/**
 * 分析elements，包括类型，数量等
 */
export class ElementsAnalyze {
    /**
     * 获取elements中的所有属于types的属性
     * @param types
     * @returns {Array}
     */
    public static getTypesOfElements(models: IElementBaseModel[] | undefined, types: string[]): IElementBaseModel[] {
        let elementArray: IElementBaseModel[] = [];
        if (!models?.length) return elementArray;
        models.forEach((child) => {
            if (types.includes(child.type)) {
                elementArray.push(child);
            }
            if (child.type === UIModelType.GROUP) {
                elementArray = elementArray.concat(this.getTypesOfElements((child as IGroupModel).children, types));
            }
        });
        return elementArray;
    }

    /**
     * 获取model中基础元素的数量
     * @param model
     * @returns
     */
    public static includeBaseElementCount(model: IElementBaseModel | IMultiplyModel | ISlideModel): number {
        switch (model.type) {
            case UIModelType.GROUP:
                return getAllChildModels(model as IGroupModel, true).length;
            case UIModelType.TABLE:
                return ((model as ITableModel).props.colWidths.length
                    * (model as ITableModel).props.rowHeights.length) + DEFAULT_VALUE;
            case UIModelType.SLIDE: {
                let elementCount = 0;
                (model as ISlideModel).children?.forEach((elementModel) => {
                    elementCount += this.includeBaseElementCount(elementModel);
                });
                return elementCount;
            }
            default:
                return DEFAULT_VALUE;
        }
    }
}
